module.exports = __webpack_public_path__ + "media/images/mobile/solutions/21-d35a18924c4e65473284b00481121e23.png";